export const writeToClipboard = (text: string | undefined): void => {
    if (text) {
      navigator.clipboard.writeText(text);
    }
  };